export default __webpack_public_path__ + "static/media/yuryu-04.1a3c606c.svg";